import { Button, Checkbox, Paper, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import { getAllDeals, IDeal } from '~/src/dash/api/deals';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { SearchDropdownSingle } from '~/src/dash/components/search-dropdown-single';
import { Panel, Panels } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorate } from '~/src/dash/utils/decorator';
import { obfuscateDealName } from '~/src/dash/utils/obfuscate';
import { routeName } from '~/src/dash/utils/routes';
import { buildDealCloneUrl } from '~/src/dash/views/deal/deal-settings-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState extends IBaseState {
  cloneDeal: boolean;
  dealList: IMenuList;
  selectedDeal?: IDeal;
}

export const DealCreateView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 4,
        marginRight: 'auto',
        marginLeft: 'auto',
        maxWidth: '600px',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);

      this.state = {
        cloneDeal: false,
        dealList: {} as IMenuList,
        selectedDeal: {} as IDeal,
      };

      this.buildRoute = this.buildRoute.bind(this);
    }

    componentDidMount() {
      const { session } = this.props;
      getAllDeals(session.publisher.ID).then((responses: any) => {
        const dealList: IMenuList = {};
        responses.forEach((resp: any) => {
          if (resp.status === 'fulfilled') {
            resp.value.forEach((deal: IDeal) => {
              const title = obfuscateDealName(
                deal,
                this.props.user.user.Username,
                `[${deal.ID}] ${deal.Name}`,
              );
              dealList[title] = {
                title,
                selected: false,
                ID: deal.ID.toString(),
                deal,
              };
            });
          }
        });
        this.setState({
          dealList,
        });
      });
    }

    cloneCheckboxChange = (event: any) => {
      this.setState({ cloneDeal: event.target.checked });
    };

    selectDeal = (deal?: IDeal) => {
      this.setState({ selectedDeal: deal });
    };

    setStateCallback = (keys: string[], values: any[], setStateCallbacks: Array<() => void>) => {
      const stateObj = {} as IState;
      for (let i = 0; i < keys.length; i++) {
        stateObj[keys[i]] = values[i];
      }
      this.setState(stateObj, () => {
        setStateCallbacks.forEach((callback: () => void) => callback());
      });
    };

    handleDealAcceptClick = (): void => {
      for (const { selected, deal } of Object.values(this.state.dealList)) {
        if (selected) {
          this.selectDeal(deal);
          break;
        }
      }
    };

    buildRoute(): string {
      const { selectedDeal } = this.state;
      const { session } = this.props;
      return buildDealCloneUrl(selectedDeal, session.publisher.ID);
    }

    render() {
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel scroll largePadding>
            <Paper
              classes={{
                root: this.props.classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Create New Deal
              </Typography>
              <div>
                <Checkbox
                  name='clone'
                  checked={this.state.cloneDeal}
                  onChange={this.cloneCheckboxChange}
                />
                Clone an existing Deal
                {this.state.cloneDeal && (
                  <SearchDropdownSingle
                    menuTitle='Deals'
                    list={this.state.dealList}
                    onChange={this.setStateCallback}
                    stateKey='dealList'
                    menuAcceptClickCallbacks={[]}
                    handleMenuAcceptClick={this.handleDealAcceptClick}
                  />
                )}
              </div>
              <div style={{ marginTop: '2rem' }}>
                <Button variant='contained' color='primary' component={Link} to={this.buildRoute()}>
                  Next
                </Button>
              </div>
            </Paper>
          </Panel>
        </Panels>
      );
    }
  },
);
